import styled from '@emotion/styled';

import AddRoundedIcon from '@mui/icons-material/AddRounded';

import useIsMobile from '../../../hooks/useIsMobile';

import { IconButton } from '@mui/material';

const TabContainer = styled.div`
  display: flex;
  gap: .4rem;
`;

const StyledTab = styled.div`
  display: flex;
  align-items: center;
  padding: .6rem 2rem;
  gap: 1rem;
  cursor: pointer;
  background-color: ${props => props.$active ?  props.theme.colors.darkBg : 'transparent'};
  transition: background-color 0.3s ease-in-out;
  border: 1px solid #ccc;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  border-bottom: none;

  @media ${props => props.theme.breaks.down("md")} { 
    padding: .2rem 1rem;
    gap: .6rem;
  }
`;

const Text = styled.div`
  font-size: 1.6rem;

  @media ${props => props.theme.breaks.down("md")} { 
    font-size: 1.3rem;
  }
`
const AddMoreTab = styled(StyledTab)`
  padding: .5rem 1rem;
  gap: .5rem;
  border: none;
  color: ${props => props.theme.colors.secondary};
`;

const TabComponent = ({ tabs, activeTab = "all", tabHandler }) => {
  const setTab = (index) => {
    tabHandler(index);
  };

  const isMobile = useIsMobile();

   return (
    <TabContainer>
      <AddMoreTab>
        {isMobile ? <IconButton size="small" color="primary"><AddRoundedIcon fontSize="small" color="secondary" /></IconButton> : <AddRoundedIcon fontSize="small" color="secondary" /> } { !isMobile ? <Text>New View</Text> : null }
      </AddMoreTab>
      {tabs.map(({Icon, label, id}, index) => (
          <StyledTab key={label} $active={activeTab === id} onClick={() => setTab(index)}>
              <Icon fontSize="small" color="icon" /> <Text>{label}</Text>
          </StyledTab>
      ))}
    </TabContainer>
  );
};

export default TabComponent;

